import { DirectiveBinding } from 'vue';

export default {
    name: 'scroll-init',
    mounted(el: Element, binding: DirectiveBinding) {
        el.addEventListener('scroll', binding.value);
    },
    beforeUnmount(el: Element, binding: DirectiveBinding) {
        el.removeEventListener('scroll', binding.value);
    },
};
